import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { DebtFormGroup, DebtModel } from 'shared';

export const clientDebtsFillFormHelper = (formArray: FormArray<FormGroup<DebtFormGroup>>, debts: Partial<DebtModel[]> = []) => {

  formArray.clear();

  for (const debt of debts) {
    const debtFormGroup = new FormGroup<DebtFormGroup>({
      id: new FormControl(debt.id),
      amount: new FormControl(debt.amount),
      clientId: new FormControl(debt.clientId),
      comment: new FormControl(debt.comment),
      contractId: new FormControl(debt.contractId),
      orderId: new FormControl(debt.orderId),
      talonId: new FormControl(debt.talonId),
      standId: new FormControl(debt.standId),
      userId: new FormControl(debt.userId),
      createdAt: new FormControl(debt.createdAt),
      finalMaturityDate: new FormControl(debt.finalMaturityDate),
      paidOff: new FormControl(debt.paidOff),
      specialAttention: new FormControl(debt.specialAttention)
    });
    formArray.controls.push(debtFormGroup);
  }

};
